// extracted by mini-css-extract-plugin
export default {"order-row":"CustomerSettingsPage_order-row__QFDxd","save-btn":"CustomerSettingsPage_save-btn__HGpqP"};